import {ConsumablePricingItem} from "./consumable-pricing-item";
import {DeviceConsumablePricingItem} from "./device-consumable-pricing-item";
import {DevicePricingItem} from "./device-pricing-item";
import {PackPricingItem} from "./pack-pricing-item";
import {DeviceConsumableWithSuppPricingItem} from "./device-consumable-with-supp-pricing-item";
import {OptionPricingItem} from "./option-pricing-item";

export enum EnumPricingItemType {
    CONSUMABLE = 'CONSUMABLE',
    DEVICE_CONSUMABLE = 'DEVICE_CONSUMABLE',
    DEVICE = 'DEVICE',
    PACK = 'PACK',
    DEVICE_CONSUMABLE_WITH_SUPP = 'DEVICE_CONSUMABLE_WITH_SUPP',
    OPTION = 'OPTION',
}

export type PricingItemType = ConsumablePricingItem | DeviceConsumablePricingItem | DeviceConsumableWithSuppPricingItem | DevicePricingItem | PackPricingItem | OptionPricingItem;

